import axios from 'axios';
import { atlasConnectorAdmin, HOST_PRESETS } from '@rm-ui/admin/atlasConnectorAdmin';

/**
 * rm-portal (Vue 2.7) wrapper around the shared Atlas connector admin
 * composable — logic lives in shared/ui/src/admin/atlasConnectorAdmin.js so
 * rm-portal-beta renders the same state. Injects the portal's global axios.
 */
export { HOST_PRESETS };

export function useAtlasConnectorAdmin() {
	return atlasConnectorAdmin(axios);
}
